import moment from "moment";

export const CONTINUITY_MAX_MONTHS = 18;

export const isContinuityRangeTooLong = (from?: Date, to?: Date): boolean =>
  from != null &&
  to != null &&
  moment(to).startOf("day").diff(moment(from).startOf("day"), "month") >
    CONTINUITY_MAX_MONTHS;
